import React from "react";
var VanillaProvider = function VanillaProvider(_ref) {
  var _config$settings$them;
  var config = _ref.config,
    children = _ref.children;
  var themeMode = (_config$settings$them = config.settings.themeMode) !== null && _config$settings$them !== void 0 ? _config$settings$them : "light";
  var compactMode = config.settings.compactMode;
  var liteMode = config.settings.liteMode;
  var base = /*#__PURE__*/React.createElement("div", {
    className: "qb-".concat(themeMode, " ").concat(compactMode ? "qb-compact" : "", " ").concat(liteMode ? "qb-lite" : "")
  }, children);
  return base;
};
export { VanillaProvider };